'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var SvgUser = function (_a) {
    var _b = _a.active, active = _b === void 0 ? false : _b, props = tslib_es6.__rest(_a, ["active"]);
    var computedProps = tslib_es6.__assign({ width: 20, height: 20, fill: 'currentColor' }, props);
    return (React__default['default'].createElement("svg", tslib_es6.__assign({ viewBox: "0 0 20 20" }, computedProps, { stroke: "none" }), active ? (React__default['default'].createElement("path", { className: "active", fillRule: "evenodd", d: "M10 0C12.7614 0 15 2.23858 15 5C15 6.88196 13.9603 8.52108 12.4239 9.37425C15.5815 10.3762 17.8902 13.2864 17.9962 16.7508L18 17V20H2V17C2 13.4265 4.34304 10.4002 7.57667 9.37361C6.03975 8.52108 5 6.88196 5 5C5 2.23858 7.23858 0 10 0Z", fill: "currentColor" })) : (React__default['default'].createElement("path", { fillRule: "evenodd", d: "M10 0C12.7614 0 15 2.23858 15 5C15 6.88196 13.9603 8.52108 12.4239 9.37425C15.5815 10.3762 17.8902 13.2864 17.9962 16.7508L18 17V20H2V17C2 13.4265 4.34304 10.4002 7.57667 9.37361C6.03975 8.52108 5 6.88196 5 5C5 2.23858 7.23858 0 10 0ZM10 10C5.52842 10 3 13.6949 3 17.003V19H17V17.003C17 13.6862 14.4716 10 10 10ZM10 1C7.79086 1 6 2.79086 6 5C6 7.20914 7.79086 9 10 9C12.2091 9 14 7.20914 14 5C14 2.79086 12.2091 1 10 1Z" }))));
};
var User = function (_a) {
    var props = tslib_es6.__rest(_a, []);
    return React__default['default'].createElement(SvgUser, tslib_es6.__assign({}, props));
};
var UserActive = function (_a) {
    var props = tslib_es6.__rest(_a, []);
    return React__default['default'].createElement(SvgUser, tslib_es6.__assign({}, props, { active: true }));
};
UserActive.displayName = 'User.Active';
User.Active = UserActive;

exports.default = User;
//# sourceMappingURL=index.js.map
